import { useMutation } from '@tanstack/react-query';
import { workPlanMainCreation } from 'services/reactQueryservices';
import { client } from '../../../react_query/query-client-configuration';
import { fiscalYearList } from 'react_query/query-keys';

const useWorkPlanMainCreatetion = () => {
    const { mutate, error, isSuccess, isError, isLoading } = useMutation({
        mutationFn: workPlanMainCreation,
        onSettled: (data, error) => {
            if (error) {
            } else {
                client.invalidateQueries({ queryKey: [fiscalYearList] });
            }
        }
    });
    return {
        mutate,
        error,
        isSuccess,
        isError,
        isLoading
    };
};

export default useWorkPlanMainCreatetion;
